import { use } from "react";
import { ConfigContext } from "../contexts/ConfigContext";

// ==============================|| CONFIG - HOOKS ||============================== //

export default function useConfig() {
  return use(ConfigContext);
}
